import React, { useEffect, useState, useCallback } from "react";
import { toast } from "sonner";
import { Loader2 } from "lucide-react";
import api from "../lib/api";
import Layout from "../components/Layout";

const AuditLog = () => {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);

  const load = useCallback(async () => {
    try {
      const { data } = await api.get("/enterprise/audit", { params: { limit: 200 } });
      setItems(data);
    } catch (err) {
      if (err.response?.status !== 403) toast.error("Could not load audit");
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => { load(); }, [load]);

  return (
    <Layout>
      <section className="mb-6">
        <p className="label-eyebrow">Governance History</p>
        <h1 className="font-heading text-4xl sm:text-5xl tracking-tight mt-2">Audit Log</h1>
        <p className="text-textmuted mt-3 max-w-2xl leading-relaxed">
          Every material administrative action across R.S.V.P. — who, what, when, and what changed.
        </p>
      </section>

      {loading ? (
        <div className="flex justify-center py-16"><Loader2 className="w-6 h-6 text-champagne animate-spin" /></div>
      ) : (
        <div className="regal-card overflow-hidden">
          <div className="divide-y divide-seam">
            {items.map((a) => (
              <div key={a.id} className="px-5 py-3 hover:bg-elevated/40">
                <div className="flex items-center gap-3 flex-wrap">
                  <span className="text-xs font-mono text-champagne">{a.action}</span>
                  <span className="text-xs text-textmuted">→ {a.target_type}</span>
                  {a.target_id && <span className="text-[10px] font-mono text-textmuted">#{a.target_id.slice(0, 8)}</span>}
                  <span className="text-xs text-textmuted ml-auto">{a.created_at?.slice(0, 19).replace("T", " ")}</span>
                </div>
                {(a.previous_value || a.new_value) && (
                  <div className="grid grid-cols-2 gap-3 mt-2 text-[11px] font-mono">
                    {a.previous_value && (
                      <div className="text-textmuted">
                        <span className="text-[#E5A09E]">before:</span> {JSON.stringify(a.previous_value).slice(0, 150)}
                      </div>
                    )}
                    {a.new_value && (
                      <div className="text-textmuted">
                        <span className="text-[#A3C293]">after:</span> {JSON.stringify(a.new_value).slice(0, 150)}
                      </div>
                    )}
                  </div>
                )}
              </div>
            ))}
          </div>
        </div>
      )}
    </Layout>
  );
};

export default AuditLog;
